import { useState } from 'react';

import { PLUS_UPGRADE_EVENTS, type PlusUpsellSource } from 'app/tracking';

import usePlusUpgradeRequested from './usePlusUpgradeRequested';
import usePlusUpgradeTracker from './usePlusUpgradeTracker';

export interface UseRequestPlusModalResult {
  /** The upsell the pop-up is open for; null while it is closed. */
  source: PlusUpsellSource | null;
  open: (source: PlusUpsellSource) => void;
  close: () => void;
}

// Opening the pop-up tracks which upsell it was opened from.
export default function useRequestPlusModal(organisationId?: string): UseRequestPlusModalResult {
  const [source, setSource] = useState<PlusUpsellSource | null>(null);
  const { requested } = usePlusUpgradeRequested(organisationId);
  const trackPlusUpgrade = usePlusUpgradeTracker(organisationId);

  return {
    source,
    open: (openedFrom) => {
      setSource(openedFrom);
      trackPlusUpgrade(PLUS_UPGRADE_EVENTS.POPUP_OPENED, openedFrom, requested);
    },
    close: () => setSource(null),
  };
}
